import React from 'react'
import Link from 'components/Link';
import styles from './style.scss'

const WarningMessage = (props) => {
    const {
        title,
        message,
        linkText,
        linkTo = '',
        target = '',
        buttonText = '',
        callback,
        children = null,
    } = props
    return (
        <div className="warning-message">
            <div className="warning-message-text-wrapper">
                {title && <h2 className="warning-message-title">{title}</h2>}
                {message && <p className="warning-message-message">
                    {message}
                    {' '}
                    {linkText && <Link to={linkTo} target={target}>{linkText}</Link>}
                </p>}
            </div>
            {callback && <div className="warning-message-button-wrapper">
                <button className="warning-message-button primary-btn" onClick={callback}>{buttonText}</button>
            </div>}
            {children}
        </div>
    )
}

export default WarningMessage
